/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import Stack from '@mui/material/Stack'
import { Chip } from '@mui/material'

import { useNavigate, useParams } from 'react-router-dom'
export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [sections, setSections] = useState([])
  const navigate = useNavigate()
  const { page_id } = useParams()
  const getAppTypes = async () => {
    const { response } = await AppService.questions_sections.filter({
      query: `section_id=${page_id}`,
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getSections = async () => {
    const { response } = await AppService.award_list.get({
      toaster: false,
    })
    if (response) {
      setSections(response.data)
    } else {
      setSections([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
    getSections()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.questions_sections.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    sections,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [

        { Header: 'chapter_name', accessor: 'chapter_name' },
        { Header: 'points', accessor: 'points' },
        { Header: 'award_name', accessor: 'award_name' },
        { Header: 'award_description', accessor: 'award_description' },
        // { Header: 'image', accessor: 'image' },
        { Header: 'type', accessor: 'type' },
        { Header: 'status', accessor: 'status' },

        { Header: 'priority', accessor: 'priority' },




        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        chapter_name: data.chapter_name,
        points: data.points,

        award_name: data.award_name,
        award_description: data.award_description ? `${data.award_description.replace(/<[^>]+>/g, "").substring(0, 30)}...` : "",
        // image: data.image,
        type: data.type,
        status: data.status,
        priority: data.priority,



        action: (
          <MDBox>

            <EditModal sx={{ marginLeft: 2 }} data={data} handleRefresh={onLoad} sections={sections} />
            <MDButton
              variant="gradient"
              color="warning"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./${data._id}`, { state: data })}
            >
              view
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
